import React from 'react';
import cx from 'classnames';
import styles from '../style.module.css';

interface Props {
  text: string;
  url: string;
  dataValue?: string;
}
export const VehicleStoreOrPerson = ({ text, url, dataValue }: Props) => {
  const vehiclesStore = cx('f14 fw4 abbey gtmGoToStore', styles.vehiclesStore);
  return (
    <a href={url} className={vehiclesStore} title={text} data-value={dataValue}>
      {text}
    </a>
  );
};
